import React, {useEffect, useState} from 'react';
import {DatePicker} from "antd";
import {useSelector} from "react-redux";
import dayjs from "dayjs";

const DG_DatePicker = props => {

    const [date, setDate] = useState()

    const {dateFormat} = useSelector(state => state.defaultSettingReducer)

    useEffect(() => {
        setDate(dayjs(props.value, dayjs.ISO_8601))
    }, [props.value])

    const subProps = {...props}
    delete subProps.onChange
    delete subProps.format
    delete subProps.className
    delete subProps.value

    function onChange(date, dateString) {
        setDate(dayjs(date))
        props?.onChange(date, dateString)
    }
    function onBlur(e) {
        const fieldDateString = e.target.value
        const fieldDate = convertStringToDate(fieldDateString, props?.format)

        let hiddenDate =   true
        if(props?.startDate){

            hiddenDate = props.startDate && (dayjs(fieldDate, props.format|| dateFormat, true).isValid() &&
                (dayjs(fieldDate).isSame(props.startDate) || dayjs(fieldDate).isAfter(props.startDate)))
        }

        if (fieldDate && hiddenDate) {
            onChange(fieldDate, fieldDateString)
        }
    }
    return (
        <DatePicker
            style={{width: '100%'}}
            {...subProps}
            onChange={onChange}
            onBlur={onBlur}
            format={props.format ? props.format : dateFormat}
            placeholder={props.placeholder || props.format || dateFormat}
            value={props.value && date}
        />
    )
};

DG_DatePicker.propTypes = {};

export default DG_DatePicker;
export function convertStringToDate(dateString,format) {

    if (dayjs(dateString, 'DD/MM/YYYY', true).isValid()) {
        return dayjs(dateString, 'DD/MM/YYYY');
    } else if (dayjs(dateString, 'D/M/YYYY', true).isValid()) {
        const formatDateString = dayjs(dateString, 'D/M/YYYY', true).format('DD/MM/YYYY');
        return dayjs(formatDateString, 'DD/MM/YYYY');
    } else if (dayjs(dateString, 'DD/M/YYYY', true).isValid()) {
        const formatDateString = dayjs(dateString, 'DD/M/YYYY', true).format('DD/MM/YYYY');
        return dayjs(formatDateString, 'DD/MM/YYYY');
    } else if (dayjs(dateString, 'D/MM/YYYY', true).isValid()) {
        const formatDateString = dayjs(dateString, 'D/MM/YYYY', true).format('DD/MM/YYYY');
        return dayjs(formatDateString, 'DD/MM/YYYY');
    } else if (dayjs(dateString, format, true).isValid()) {
        const formatDateString = dayjs(dateString, format, true).format(format);
        return dayjs(formatDateString, format);
    } else {
        return null
    }

}
